import { SUPPORTED_LANGS } from '@/lib/intakeWizardI18n';

export default function LanguageToggle({ lang, onChange }) {
  return (
    <div className="inline-flex items-center border border-[#e3e3e3] dark:border-white/10 rounded-full overflow-hidden" role="group" aria-label="Language">
      {SUPPORTED_LANGS.map((code) => (
        <button
          key={code}
          type="button"
          onClick={() => onChange(code)}
          aria-pressed={lang === code}
          className={`px-3 py-1 text-xs font-medium uppercase transition-colors ${
            lang === code
              ? 'bg-[#98139C] text-white'
              : 'text-[#30302F] dark:text-white hover:bg-[#faf8fb] dark:hover:bg-white/5'
          }`}
        >
          {code}
        </button>
      ))}
    </div>
  );
}
